module.exports = __webpack_public_path__ + "static/media/REEF-BNB.ec15d1b9.svg";